import 'slick-carousel'
import arrow from '../../images/arrow.svg'

export function logoSlider() {
  $('.slk-search-slider').not('.slick-initialized').slick({
    lazyLoad: 'ondemand',
    dots: false,
    arrows: true,
    prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><img src="/wp-content/themes/buy2themeforest-child/dist/${arrow}" width="32"></button>`,
    nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button"><img src="/wp-content/themes/buy2themeforest-child/dist/${arrow}" width="32"></button>`,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    initialSlide: 0
  });
}

export function popupSlider() {
  // if ($('.popup-slider').length > 0 ) {
  $(".popup-slider").not('.slick-initialized').slick({
      lazyLoad: 'ondemand',
      dots: false,
      arrows: true,
      prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><img src="/wp-content/themes/buy2themeforest-child/dist/${arrow}" width="32"></button>`,
      nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button"><img src="/wp-content/themes/buy2themeforest-child/dist/${arrow}" width="32"></button>`,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      initialSlide: 0
    });
  // }
}

export function searchLogoSlider() {
  $(document).ajaxComplete(function(){
    logoSlider();
  });
}

export function homeGallerySlide() {
    if ($('.slk-gallery-slider').length > 0 ) {
        $('.slk-gallery-slider').not('.slick-initialized').slick({
            lazyLoad: 'ondemand',
            dots: false,
            arrows: true,
            prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><img src="/wp-content/themes/buy2themeforest-child/dist/${arrow}" width="32"></button>`,
            nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button"><img src="/wp-content/themes/buy2themeforest-child/dist/${arrow}" width="32"></button>`,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false
        });
    }
}